export function CompareAddedSvgIcon() {
  return (
    <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="44" height="44" rx="12" fill="#F0FAFF" />
      <path
        d="M15 23.75C15 23.3358 15.3358 23 15.75 23H20.75C21.1642 23 21.5 23.3358 21.5 23.75C21.5 24.1642 21.1642 24.5 20.75 24.5H15.75C15.3358 24.5 15 24.1642 15 23.75Z"
        fill="#0685C3"
      />
      <path
        d="M15 27.75C15 27.3358 15.3358 27 15.75 27H20.75C21.1642 27 21.5 27.3358 21.5 27.75C21.5 28.1642 21.1642 28.5 20.75 28.5H15.75C15.3358 28.5 15 28.1642 15 27.75Z"
        fill="#0685C3"
      />
      <path
        d="M15 15.75C15 15.3358 15.3358 15 15.75 15H28.25C28.6642 15 29 15.3358 29 15.75C29 16.1642 28.6642 16.5 28.25 16.5H15.75C15.3358 16.5 15 16.1642 15 15.75Z"
        fill="#0685C3"
      />
      <path
        d="M15 19.75C15 19.3358 15.3358 19 15.75 19H28.25C28.6642 19 29 19.3358 29 19.75C29 20.1642 28.6642 20.5 28.25 20.5H15.75C15.3358 20.5 15 20.1642 15 19.75Z"
        fill="#0685C3"
      />
      <path
        d="M28.4316 23.5107C28.7017 23.197 29.1753 23.1618 29.4893 23.4316C29.803 23.7017 29.8382 24.1753 29.5684 24.4893L26.1309 28.4893C25.9884 28.6548 25.7809 28.75 25.5625 28.75C25.3441 28.75 25.1366 28.6548 24.9941 28.4893L23.4316 26.6709L23.3838 26.6104C23.1664 26.2986 23.2165 25.8665 23.5107 25.6133C23.8053 25.3602 24.24 25.3759 24.5156 25.6377L24.5684 25.6934L25.5615 26.8486L28.4316 23.5107Z"
        fill="#0685C3"
      />
    </svg>
  );
}
